import React, { useState } from 'react';

import { Button, notification, Popconfirm } from 'antd';

import { MailOutlined } from '@ant-design/icons';

import { sleep } from '../../lib/Sleep';
import { sendEmailsForConsumptionReadings } from '../../services/Consumption.service';

type Props = {
    selectedReadings: Consumption.Reading[];
    clearSelection: () => void;
};

export function ConsumptionSendEmail({ selectedReadings, clearSelection }: Props) {
    const [isSending, setIsSending] = useState(false);
    const [isConfirmVisible, setIsConfirmVisible] = useState(false);


    const handleSendEmails = async () => {
        setIsSending(true);

        const ids = selectedReadings.map(r => r.id);

        const response = await sendEmailsForConsumptionReadings({ids});

        await sleep(1000);
        setIsSending(false);
        setIsConfirmVisible(false);

        notification.open(response);

    };

    return (
        <Popconfirm
            title="Tem certeza que deseja enviar os e-mails para as leituras selecionadas?"
            open={isConfirmVisible}
            placement="left"
            okText="Sim"
            cancelText="Não"
            okButtonProps={{ loading: isSending }}
            onConfirm={handleSendEmails}
            onCancel={() => setIsConfirmVisible(false)}
        >
            <Button
                type={selectedReadings.length > 0 ? 'primary' : 'dashed'}
                icon={<MailOutlined />}
                disabled={selectedReadings.length === 0}
                onClick={() => setIsConfirmVisible(true)}
            >
                Enviar emails ({selectedReadings.length})
            </Button>
        </Popconfirm>
    );
}
